const app = {
  namespaced: true,
  state: {
    cancelTokenArr: []
  },
  mutations: {
    pushToken (state, payload) {
      state.cancelTokenArr.push(payload.cancelToken)
      // console.log(state.cancelTokenArr);
    },
    clearToken ({ cancelTokenArr }) {
      cancelTokenArr.forEach(item => {
        item('路由跳转取消请求')
      })
      cancelTokenArr = []
    },
  }
}

export default app
